import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { red } from '@mui/material/colors';
import FormLabel from '@mui/material/FormLabel';


export default function ProfileSelection({profile,handleProfileChange}) {

  const controlProps = (item) => ({
    checked: profile === item,
    onChange: handleProfileChange,
    value: item,
    name: 'row-radio-buttons-group',
    inputProps: { 'aria-label': item },
    sx: profile === item ? {
      color: red[800],
      '&.Mui-checked': {
        color: red[600],
      },
    } : {}
  });

  return (
    <FormControl style={{marginTop:"20px"}}>
      <FormLabel id="demo-row-radio-buttons-group-label" color='warning' style={{textAlign:'left',fontWeight:"bold",marginLeft:"20px",fontSize:'18px'}}>Select Your Profile</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={profile}
        style={{display: 'flex', flexDirection: 'row',marginLeft:'40px'}}
        onChange={handleProfileChange}
      >
        <FormControlLabel value="rental-textile-laundry" control={<Radio  {...controlProps('rental-textile-laundry')} />} label="I'm a rental textile laundry"/>
        <FormControlLabel value="FR-Clothing" control={<Radio {...controlProps('FR-Clothing')} />} label="I'm a user of FR Clothing" />
      </RadioGroup>
    </FormControl>
  );
}
